import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL;

interface CheckVisitCodeData {
    visit_id: string;
    guest: string;
}



interface CheckVisitCodeState {
    loading: boolean;
    error: string | null;
    success: boolean;
    data: any;
    visitCodeResponse: any;
    userData: any;
}

const initialState: CheckVisitCodeState = {
    loading: false,
    error: null,
    success: false,
    data: [],
    userData: [],
    visitCodeResponse: []
};

export const checkVisitCode = createAsyncThunk(
    'checkVisitCode/checkVisitCode',
    async (data: CheckVisitCodeData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${baseURL}/api/video-call/check-visit-code`, data);
            return response.data;
        } catch (error: any) {
            // Handle the actual API error structure
            const apiError = error.response?.data;

            let errorMessage = 'Failed to send checkVisitCode';

            if (apiError?.message) {
                errorMessage = apiError.message;
            } else if (apiError?.error?.description) {
                errorMessage = apiError.error.description;
            } else if (error.message) {
                errorMessage = error.message;
            }

            return rejectWithValue({
                message: errorMessage,
                statusCode: error.response?.status || 500,
                timestamp: new Date().toISOString()
            });
        }
    }
);

export const singleVisit = createAsyncThunk(
    'single/singleVisit',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${baseURL}/api/video-call/single-visit`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Failed to send singleVisit');
        }
    }
);

export const endCall = createAsyncThunk(
    'single/endCall',
    async (data: any & { meeting_id: string }, { rejectWithValue }) => {
        try {
            const { meeting_id, ...requestData } = data; // Extract meeting_id from data
            const response = await axios.post(`${baseURL}/api/video-call/terminate-visit/${meeting_id}`, requestData);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Failed to end call');
        }
    }
);

const checkVisitCodeSlice = createSlice({
    name: 'checkVisitCode',
    initialState,
    reducers: {
        resetVideoState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkVisitCode.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(checkVisitCode.fulfilled, (state, action) => {
                state.loading = false;
                state.userData = action?.payload;
                state.visitCodeResponse = action.payload?.data
            })
            .addCase(checkVisitCode.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
                state.success = false;
            })
            .addCase(singleVisit.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
            })
            .addCase(singleVisit.fulfilled, (state, action) => {
                state.data = action.payload?.data
                state.loading = false;
                state.success = true;
            })
            .addCase(singleVisit.rejected, (state, action) => {
                console.log('aaa', action);
                state.loading = false;
                state.error = action.payload as string;
                state.success = false;
            })
            .addCase(endCall.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
            })
            .addCase(endCall.fulfilled, (state, action) => {
                console.log(action)
                state.loading = false;
                state.success = true;
            })
            .addCase(endCall.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
                state.success = false;
            });
    },
});

export const { resetVideoState } = checkVisitCodeSlice.actions;
export default checkVisitCodeSlice.reducer;
